import { render, staticRenderFns } from "./EmployeeSettingPage.vue?vue&type=template&id=2b31c680&scoped=true&"
import script from "./EmployeeSettingPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31c680",
  null
  
)

export default component.exports